export const countryConfigRS = {
  home: {
    skeleton: {
      banner: true,
      bubbles: true,
      featuredProducts: true,
      services: true,
      starredProductLists: 0,
      starredCards1: false,
      starredCards2: false,
      posts: false
    }
  },
  'landing-courier': {
    bikeCollection: 'za-bicikle-i-skutere-2',
    carCollection: 'za-vozace-automobila-3'
  }
};
